function Toast({
  title,
  message,
  type = "success",
  onClose
}) {
  if (!message && !title) {
    return null;
  }

  const isError = type === "error";
  const isWarning = type === "warning";

  const accentColor = isError
    ? "#ff4d4d"
    : isWarning
    ? "#f5b942"
    : "#e10600";

  const icon = isError ? "✕" : isWarning ? "!" : "✓";

  return (
    <div style={toastStyle}>
      <div style={{ ...accentStyle, backgroundColor: accentColor }} />

      <div style={contentStyle}>
        <div style={titleRowStyle}>
          <span style={{ ...iconStyle, backgroundColor: accentColor }}>
            {icon}
          </span>

          <strong style={titleStyle}>
            {title ||
              (isError
                ? "Something went wrong"
                : isWarning
                ? "Heads up"
                : "Success")}
          </strong>
        </div>

        {message && <p style={messageStyle}>{message}</p>}

        <div style={progressTrackStyle}>
          <div
            style={{
              ...progressBarStyle,
              backgroundColor: accentColor
            }}
          />
        </div>
      </div>

      <button onClick={onClose} style={closeButtonStyle}>
        ×
      </button>
    </div>
  );
}

const toastStyle = {
  position: "fixed",
  top: "calc(88px + env(safe-area-inset-top))",
  right: "18px",
  zIndex: 20000,
  backgroundColor: "#181818",
  color: "white",
  border: "1px solid #2b2b2b",
  borderRadius: "16px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "stretch",
  minWidth: "290px",
  maxWidth: "380px",
  overflow: "hidden",
  animation: "toastSlideIn 0.22s ease-out"
};

const accentStyle = {
  width: "5px",
  flexShrink: 0
};

const contentStyle = {
  padding: "14px 12px 12px",
  flex: 1
};

const titleRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "6px"
};

const iconStyle = {
  width: "22px",
  height: "22px",
  borderRadius: "50%",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "12px",
  fontWeight: "bold",
  flexShrink: 0
};

const titleStyle = {
  display: "block",
  fontSize: "14px"
};

const messageStyle = {
  margin: "0 0 10px",
  fontSize: "14px",
  opacity: 0.82,
  lineHeight: "1.4"
};

const progressTrackStyle = {
  width: "100%",
  height: "3px",
  backgroundColor: "#2b2b2b",
  borderRadius: "999px",
  overflow: "hidden"
};

const progressBarStyle = {
  height: "100%",
  width: "100%",
  borderRadius: "999px",
  animation: "toastProgress 3s linear forwards"
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  color: "white",
  cursor: "pointer",
  fontSize: "22px",
  padding: "8px 12px",
  opacity: 0.75
};

export default Toast;